"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function Header({
  title,
  subTitle,
  description,
  description1,
  description2,
  description3,
  wrapperClassName = "",
  titleClassName = "",
  descriptionClassName = "",
  descriptionClassName1 = "",
  descriptionClassName2 = "",
  descriptionClassName3 = "",
  uppercase = false,
}) {
  const isDark = useIsDark();

  const wrapperClasses = twMerge(
    "relative flex flex-col items-start justify-center mt-0 mb-6 xl:mb-12 z-10",
    wrapperClassName
  );

  const headingClasses = twMerge(
    "text-left font-semibold font-manrope text-[18px] sm:text-xl md:text-[24px] xl:text-[28px] 3xl:text-3xl text-foreground",
    uppercase ? "uppercase" : "",
    titleClassName
  );

  const subHeadingClasses =
    "font-semibold font-manrope text-[16px] sm:text-[18px] md:text-[20px] xl:text-[24px] 3xl:text-[26px] text-foreground mt-4";

  const paragraphClasses = twMerge(
    `text-left font-manrope font-medium text-sm md:text-[16px] xl:text-[18px] 3xl:text-[22px] leading-normal mt-4 ${
      isDark ? "text-[#FFFFFF]" : "text-[#5A5A6E]"
    }`,
  );


  return (
    <div className={wrapperClasses}>
      {title ? <p className={headingClasses}>{title}</p> : null}
      {subTitle ? <p className={subHeadingClasses}>{subTitle}</p> : null}
      {description ? <p className={twMerge(paragraphClasses, descriptionClassName)}>{description}</p> : null}
      {description1 ? <p className={twMerge(paragraphClasses, descriptionClassName1)}>{description1}</p> : null}
      {description2 ? <p className={twMerge(paragraphClasses, descriptionClassName2)}>{description2}</p> : null}
      {description3 ? <p className={twMerge(paragraphClasses, descriptionClassName3)}>{description3}</p> : null}
    </div>
  );
}
